import { useApolloClient } from '@apollo/client';
import { track } from '@bnnvara/analytics/src/track';
import { useBrand } from '@bnnvara/brand';
import NewsletterUI from '@bnnvara/newsletter';
import { useRouter } from 'next/router';
import React from 'react';

import { SubscribeToNewsletterMutation } from '../../api/mutations/subscribe.gql';

const NewsletterSubscription = () => {
  const brand = useBrand();
  const {
    query: { slug },
  } = useRouter();

  const apolloClient = useApolloClient();

  const { subscriptionlistName, subscriptionlistDescription } = brand;

  // Removes the newsletter block from varagids/Sinancanhelpt
  if (slug === 'Sinancanhelpt') {
    return null;
  }

  return (
    <NewsletterUI
      onSubmit={async ({ email }) => {
        try {
          await apolloClient.mutate({
            mutation: SubscribeToNewsletterMutation,
            variables: {
              input: {
                listName: subscriptionlistName,
                email,
              },
            },
          });
          track(
            'newsletter-subscribe',
            'click',
            `subscribe-${subscriptionlistName}`
          );
          return true;
        } catch (error) {
          return {
            error: {
              message: 'failure',
              fields: {},
            },
          };
        }
      }}
      name={subscriptionlistName}
      description={subscriptionlistDescription}
    />
  );
};

export default NewsletterSubscription;
